<template>  
<div  class="mb-3" :class="FormDataType.FieldSize">
    <b-form-group 
    :class="title_position"
    id="example text"
    :label-cols-lg="labels_lg"
    :label="FormDataType.FieldTitle" 
    label-for="text">
    
    
    <textarea 
    :rows="rows"
    :class="{'is-invalid': v.$error,}"  
    v-model="InputName" 
    @input="$emit('input', InputName)" 
    class="form-control" 
    :disabled="FormDataType.Disabled"
    ></textarea>


    <div v-if="v.$error" class="invalid-feedback" >
    <span v-if="v.required == false"> {{ $t("ValidationMessage.required") }}</span>
    <span v-if="v.numeric == false">Bu Alan numeric.</span>
    </div>
    </b-form-group>  
</div> 
</template> 

<script>  
export default {
  data() {
    return { 
        InputName:""
    }
  },
  props: {
    v: {
      type: Object,
    },
    FormDataType: {},
    FormPost: String,
    Value: String,
    title_position:String,
    labels_lg:Number,
    rows:Number
  }, 
  watch: {
        FormPost() { 
             this.$v.$touch()
        },
         Value(){
      this.InputName = this.Value;
    }
  },
  created: function() {  
    this.InputName = this.Value;
  }
};
</script>
